import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../axios";
import urls from "../Utils/urls";
import { commonToast } from "../Utils";
import { toast } from "react-toastify";

export const useNSF = () => {
  const [showUrgentModal, setShowUrgentModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyItems, setHistoryItems] = useState([]);
  const navigate = useNavigate();
  const nsfState = useSelector((state) => state.nsf?.nsfData?.data);

  const handleSendAlert = useCallback((nsfCase) => {
    setSelectedCase(nsfCase || null);
    // setShowDetailModal(true);
  }, []);

  const handleSendNSFAlert = useCallback(() => {
    setShowUrgentModal(true);
  }, []);

  const handleCloseUrgentModal = useCallback(() => {
    setShowUrgentModal(false);
  }, []);

  const handleShowDetailModal = useCallback(() => {
    setShowDetailModal(true);
  }, []);

  const handleCloseDetailModal = useCallback(() => {
    setShowDetailModal(false);
    setSelectedCase(null);
  }, []);

  const handleShowHistory = useCallback(
    (nsfCase) => {
      if (nsfCase) {
        setSelectedCase(nsfCase);
        const items = nsfState?.grouped?.[nsfCase?.LoanRecID] || [];
        setHistoryItems(items);
      }
      setShowHistoryModal(true);
    },
    [nsfState]
  );

  const handleCloseHistory = useCallback(() => {
    setShowHistoryModal(false);
    setHistoryItems([]);
  }, []);

  const handleContactSupport = useCallback(() => {
    navigate("/help");
  }, [navigate]);

  const handleUpdatePaymentMethod = useCallback(() => {
    navigate("/add-bank-account");
  }, [navigate]);

  const handleRetryPayment = useCallback(async () => {
    try {
      const loanAccount = selectedCase?.loanNumber || selectedCase?.LoanNumber;

      if (!loanAccount) {
        throw new Error("Missing loan account");
      }
      const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
      const payload = {
        loan_account: loanAccount,
        subject: `NSF Payment Retry Request for ${selectedCase?.borrower} - ${selectedCase?.loanNumber}`,
        description: `Please retry last failed payment — Amount: $${selectedCase?.amount}, Borrower: ${selectedCase?.borrower}, Failed: ${selectedCase?.dateFormatted}, Loan #: ${selectedCase?.loanNumber}, Next Due: ${selectedCase?.nextDueDateFormatted}, NSF Fee: ${selectedCase?.nsfFee}.`,
        user_id: `${userDetails.user_id}`,
        contact_email: userDetails.email,
      };

      const id = toast.loading("Retrying Payment");
      const res = await axios.post(urls.borrower.retryPayment, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      });
      const message = res?.data?.Response?.[0]?.MESSAGE;
      if (message === "Ticket is Already Exist.") {
        toast.update(id, {
          render: message,
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      } else {
        toast.update(id, {
          render: message,
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      }
      setShowDetailModal(false);
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert("Failed to submit retry payment request. Please try again.");
      // Also log for debugging
      // eslint-disable-next-line no-console
      console.error("Retry payment error", error);
    }
  }, [selectedCase]);

  const handleUrgentModalActions = {
    onHandleNow: useCallback(() => {
      console.warn("Handle Now clicked");
      setShowUrgentModal(false);
      // Add urgent action logic
    }, []),
    onReviewLater: useCallback(() => {
      console.warn("Review Later clicked");
      setShowUrgentModal(false);
      // Add review later logic
    }, []),
  };

  return {
    // State
    showUrgentModal,
    showDetailModal,
    selectedCase,
    showHistoryModal,
    historyItems,

    // Actions
    handleSendAlert,
    handleSendNSFAlert,
    handleCloseUrgentModal,
    handleShowDetailModal,
    handleCloseDetailModal,
    handleShowHistory,
    handleCloseHistory,
    handleContactSupport,
    handleUpdatePaymentMethod,
    handleRetryPayment,
    handleUrgentModalActions,
  };
};
